(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ts-quantity-calculator"] && !Shopify.designMode) return;
  try {
    function tsCalculate(panel){
  const number=(selector)=>Number(panel.querySelector(selector)?.value);
  const area=number('[data-area]'),rate=number('[data-rate]'),pack=number('[data-pack]'),factor=number('[data-unit]');
  const output=panel.querySelector('output');
  if(![area,rate,pack,factor].every(n=>Number.isFinite(n)&&n>0)){output.textContent=panel.dataset.start;return;}
  const required=area*rate*factor, count=required/pack;
  if(!Number.isFinite(count)||!Number.isFinite(required)){output.textContent=panel.dataset.start;return;}
  const format=n=>n.toLocaleString('en-GB',{maximumSignificantDigits:6});
  let message=panel.dataset.required+' '+format(required)+(panel.dataset.kind==='liquid'?' L':' kg')+'\n'+panel.dataset.packs+' '+Math.ceil(count-Number.EPSILON*Math.max(1,count));
  const water=number('[data-water-rate]');
  if(panel.dataset.kind==='liquid'&&water>0&&Number.isFinite(water)){message+='\n'+panel.dataset.water+' '+format(area*water/10000)+' L';}
  output.textContent=message;
}
document.addEventListener('input',event=>{const panel=event.target.closest('.ts-quantity-calculator');if(panel)tsCalculate(panel);});
document.addEventListener('change',event=>{const panel=event.target.closest('.ts-quantity-calculator');if(panel)tsCalculate(panel);});
document.addEventListener('toggle',event=>{
  const panel=event.target;
  if(!panel.matches?.('.ts-quantity-calculator')||!panel.open||panel.dataset.initialised)return;
  panel.dataset.initialised='true';
  const pattern=panel.dataset.kind==='liquid'?/(\d+(?:\.\d+)?)\s*(?:litres?|liters?|ltr|l)\b/i:/(\d+(?:\.\d+)?)\s*kg\b/i;
  const match=panel.dataset.variant.match(pattern)||panel.dataset.title.match(pattern);
  if(match)panel.querySelector('[data-pack]').value=match[1];
},true);
  } catch(e) { console.error(e); }
})();

})();
